import { toast } from "sonner";
import { api, formatApiError } from "@/context/AuthContext";

const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

export async function openBookingPayment({ bookingId, details, onPaid, onFailed }) {
  try {
    const { data: order } = await api.post("/payments/create-order", { booking_id: bookingId });
    const loaded = await loadRazorpayScript();
    if (!loaded) throw new Error("Payment checkout failed to load");
    const rz = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      name: "NUC Service",
      description: "Service booking fee",
      order_id: order.order_id,
      prefill: { name: details.name, email: details.email, contact: details.phone },
      theme: { color: "#1E3A8A" },
      handler: async (resp) => {
        try {
          await api.post("/payments/verify", {
            booking_id: bookingId,
            razorpay_order_id: resp.razorpay_order_id,
            razorpay_payment_id: resp.razorpay_payment_id,
            razorpay_signature: resp.razorpay_signature,
          });
          toast.success("Payment confirmed — your booking is locked in.");
          onPaid?.();
        } catch {
          toast.error("Payment could not be verified. Quote your payment ID when we call.");
        }
      },
      modal: {
        ondismiss: () => toast("Payment skipped — you can pay at the service desk."),
      },
    });
    rz.on("payment.failed", async () => {
      try {
        await api.post("/payments/failed", { booking_id: bookingId });
      } catch {
        // status stays unpaid
      }
      toast.error("Payment failed. No money was captured — you can try again or pay at the desk.");
      onFailed?.();
    });
    rz.open();
  } catch (err) {
    toast.error(formatApiError(err));
  }
}
